import { merge } from "lodash";
import { CustomProvider, DateRangePicker as RsuiteDateRangePicker } from "rsuite";
import { Theme } from "@material-ui/core";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  datePickerBox: {
    "&.rs-picker-default ": {
      "& .rs-picker-toggle.rs-btn": {
        background: "#293368 !important",
        borderRadius: "10px",
        border: "1px solid #8476EF",
        padding: "14px 32px",
        fontWeight: 500,
      },
      "& .rs-picker-toggle-caret": {
        display: "none",
      },
    },
    "& .rs-picker-toggle-textbox": {
      background: "#293368",
      color: "#fff",
      fontSize: "13px",
    },
    "& .rs-stack": {
      "& .rs-stack-item": {
        "& .rs-picker-toggle-clean": {
          top: "14px !important",
          // background: "blue",
        },
      },
      "& .rs-picker-toggle-textbox": {
        padding: "14px 32px",
        color: "#fff",
      },
    },
    "& .rs-picker-toggle-value, .rs-picker-toggle-placeholder": {
      color: "#fff !important",
    },
  },
}));

export default function DateRangePicker({ props }: any) {
  const classes = useStyles();

  const mergedProps = merge(
    {
      ranges: [],
      className: classes.datePickerBox,
      showMeridian: true,
      format: "MM-dd-yy - HH:mm",
      placeholder: "MM/DD/YY - HH:MM to MM/DD/YY - HH:MM",
      color: "red",
    },
    props
  );

  return (
    <CustomProvider theme="dark">
      <RsuiteDateRangePicker {...mergedProps} />
    </CustomProvider>
  );
}
